/**
 * Copyright © 2026 Adnuntius AS.
 */

const FORMULA_PREFIX = /^\s*[=+\-@]/;

/** Encode one comma-separated value and prevent spreadsheet formula execution. */
export function escapeCsvValue(value: any): string {
  if (value === undefined || value === null) {
    return '';
  }

  let text = value instanceof Date ? value.toISOString() : String(value);
  if (typeof value === 'string' && FORMULA_PREFIX.test(text)) {
    text = "'" + text;
  }
  return /[",\r\n]/.test(text) ? '"' + text.replace(/"/g, '""') + '"' : text;
}
